import { type AppNotificationDto } from "../dto/app-notification.dto";
import { useAppNotificationApi } from "../api/app-notification.api";
import { defineStore } from "pinia";

export interface AppNotificationStoreState {
  data: AppNotificationDto[];
  lastRequestedPage: number;
  unread: number;
}

export const useAppNotificationStore = defineStore("appNotification", {
  state: (): AppNotificationStoreState => {
    return { data: [], lastRequestedPage: 0, unread: 0 };
  },
  actions: {
    async getMine(page: number = 1) {
      const pageSize = 20;
      let offset: number = page > 1 ? this.data.length : 0;
      if (page < this.lastRequestedPage) {
        offset = 0;
      }
      const result = await useAppNotificationApi().getMine(offset, pageSize);
      if (offset === 0) {
        this.data = result.data;
      } else {
        const ids = new Set(this.data.map(item => item.id));
        this.data = [...this.data, ...result.data.filter(item => !ids.has(item.id))];
      }
      this.lastRequestedPage = result.page;
      this.unread = result.unread;
    },
    async markAsRead(id: number) {
      await useAppNotificationApi().markAsRead(id);
      const found = this.data.find(item => item.id === id);
      if (found) {
        found.isRead = true;
        this.unread -= 1;
      }
    },
    async markAllAsRead() {
      await useAppNotificationApi().markAllAsRead();
      this.data = this.data.map(item => ({ ...item, isRead: true }));
      this.unread = 0;
    },
    async delete(id: number) {
      await useAppNotificationApi().delete(id);
      const found = this.data.find(item => item.id === id);
      if (found && !found.isRead) {
        this.unread = Math.max(0, this.unread - 1);
      }
      this.data = this.data.filter(item => item.id !== id);
      if (!this.data.length) {
        await this.getMine(1);
      }
    },
    async removeAll() {
      await useAppNotificationApi().removeAll();
    },
  },
});
